<template>
  <div class="salesmanGiftPage">    
    <XR-head titleText="大礼包" :rightShow="true" ref="headObj"></XR-head>
    <div class="page-content">
        <img src="/static/salesman/gift/buhuo-bg1.png" class="bg" />
        
      <div class="btn-list">
        <mu-row gutter>
          <mu-col width="100" tablet="50" desktop="33">
            <mu-raised-button label="收到了" class="btn" fullWidth @click="openDialog()" />
          </mu-col>
        </mu-row>
        <mu-row gutter>
          <mu-col width="100" tablet="50" desktop="33">
            <mu-raised-button label="没收到" class="btn" fullWidth @click="unGet()" />
          </mu-col>
        </mu-row>
      </div>
      <mu-dialog :open="dialog" title="提醒" @close="closeDialog">
        <span>确定收到货以后，将不再提示</span>
        <mu-flat-button slot="actions" @click="closeDialog" primary label="取消"/>
        <mu-flat-button slot="actions" primary @click="allreadyGet" label="确定"/>
      </mu-dialog>
    </div>
    <XR-toast @onClose="goBack" ref="XRtoast"></XR-toast>
  </div>
</template>

<script>
export default {
  data(){
    return {
      dialog:false
    }
  },
  mounted(){

  },
  methods:{
    allreadyGet(){     
      this.closeDialog()     
      const ths = this;
      this.$post("/Salesman/SalesmanServer/AllreadyGetGift")
      .then(function(res) {
        if (res.IsSuccess) {     
          ths.$refs.XRtoast.success(res.Msg, true);
        }else{
          ths.$refs.XRtoast.failed(res.Msg, true);
        }
      })
      .catch(function(err) {
        console.log(err);
      });
    },
    unGet(){    
      const ths = this;
      this.$post("/Salesman/SalesmanServer/GetSalesmanOrderDeliveryAddress")
      .then(function(res) {
        if (res.IsSuccess) {   
          ths.$router.push('/salesman/giftAddress')
        }else{
          ths.$refs.XRtoast.hide();
        }
      })
      .catch(function(err) {
        console.log(err);
      });
    },    
    openDialog () {
      this.dialog = true
    },
    closeDialog () {
      this.dialog = false
    },
    goBack(){
      this.$router.goBack()
    }
  }
}
</script>

<style>
body .salesmanGiftPage { background: #EA4087;}
.salesmanGiftPage .bg{ width: 100%;}
.salesmanGiftPage .btn-list{ padding: 0 10%;}
.salesmanGiftPage .btn-list .btn{ height: 50px; margin-bottom: 10px;}
</style>



// WEBPACK FOOTER //
// src/pages/salesman/salesmanGift.vue